<template>
  <div>
    <div class="details-card--quote-price-wrapper">
      <LsIcon type="quote" size="xlg" class="details-card--quote-icon" />
      <div class="details-card--price-info">
        <span class="details-card--price" test-id="price">
          {{ currentQuote.price | currency }}
        </span>
        <span class="details-card--price-text"> {{ currentQuote[iqType].copy.action }} </span>
      </div>
    </div>
    <div v-for="(detail, idx) in details" :key="detail.title" class="details-card--details">
      <div :class="['details-card--description', { 'border-top': idx }]">
        <!-- eslint-disable-next-line prettier/prettier -->
                <p class='has-text-weight-bold'>
                    {{ detail.title }}
                </p>
        <div v-if="!idx" class="details-card--edit-button">
          <LsButton
            track-id="instant_quote_details_card-edit_button"
            text="edit"
            bg-color="primary"
            :min-width="false"
            test-id="details-card-edit-button"
            @click="editButtonMethod(1)"
          />
        </div>
      </div>
      <!-- eslint-disable-next-line prettier/prettier -->
            <p
                test-id="details_values"
                 class="details-card--value"
            >
                {{ detail.value }}
            </p>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsIcon, LsButton } from '@/components/common';
import { lsFilters } from 'ls-vue-common';

export default {
  name: 'InstantQuoteDetailsCard',
  components: { LsIcon, LsButton },
  props: {
    currentQuote: VueTypes.shape({
      price: VueTypes.number,
      type: VueTypes.string.isRequired,
    }).loose.isRequired,
    cycle: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    editButtonMethod: VueTypes.func.isRequired,
  },
  computed: {
    iqType() {
      return this.currentQuote.type;
    },
    details() {
      return [
        {
          title: 'Frequency',
          value: lsFilters.frequency({ cycle: this.cycle }),
        },
        {
          title: 'Crew',
          value: this.name,
        },
        ...this.currentQuote[this.iqType].copy.description,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.details-card--quote-price-wrapper {
  display: flex;
  align-items: center;
  padding: 10px 0 20px 0;
}

.details-card--quote-icon {
  margin-top: -2px;
}

.details-card--price-info {
  margin-left: 8px;
}

.details-card--price {
  font-size: $size-1;
  color: $primary;
  font-weight: bold;
  @media (max-width: $mobile-max-width) {
    margin-left: 0px;
    font-size: $size-2;
  }
}

.details-card--price-text {
  font-size: $size-4;
  color: $primary;
  padding-left: 4px;
  @media (max-width: $mobile-max-width) {
    font-size: $size-5;
    padding-left: 0px;
  }
}

.details-card--details {
  background-color: $primary-light;
  padding: 0 20px;
}

.details-card--value {
  padding: 4px 0 15px 0;
}

.details-card--edit-button {
  height: 15px;
}

.details-card--description {
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  &.border-top {
    border-top: 1px solid $special-recommended-services;
  }
}
.themed-app {
  .details-card--price {
    font-size: $theme-txt-headline;
    color: $theme-color-primary;
    @media (max-width: $mobile-max-width) {
      font-size: $theme-txt-title;
    }
  }
  .details-card--price-text {
    font-size: $theme-txt-body-lg;
    color: $theme-color-primary;
    @media (max-width: $mobile-max-width) {
      font-size: $theme-txt-body;
    }
  }
  .details-card--details {
    background-color: $theme-color-primary-light;
  }
  .details-card--description {
    &.border-top {
      border-color: $theme-color-primary-light;
    }
  }
}
</style>
